import { useDispatch, useSelector } from 'react-redux';
import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import Funnel from '@/components/Funnel';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './productionRate.module.scss';
import PerformanceCard from '../PerformanceCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceProductionRateCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function ProductionRate() {
  const dispatch = useDispatch();
  const {
    loading,
    hasFetched,
    rate: mainRate,
    percentage_status,
    variation,
    icon,
    funnel,
  } = useSelector((state) => state.DashboardSlice.productionRate);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  const colors = ['#367083', 'var(--colors-brand-secondary-700)'];
  const rates = [
    {
      id: 1,
      percentage: funnel.added_percentage,
      text: Trans(
        translations,
        'ProductionRateCard.CountAppraisals',
        String(funnel.appraisals_count)
      ),
    },
    {
      id: 2,
      percentage: null,
      text: Trans(
        translations,
        'ProductionRateCard.CountAdded',
        String(funnel.added_count)
      ),
    },
  ];

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceProductionRateCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'productionRate',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="production-rate"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'ProductionRate')}
      </PerformanceCard.Header>

      <PerformanceCard.Summary
        value={mainRate}
        tendency={variation}
        icon={icon}
        percentageStatus={percentage_status}
      />

      <PerformanceCard.Content>
        <Box className={styles.productionRate}>
          <Box className={styles.funnelsContainer}>
            {rates.map((rate, index) => (
              <Box key={rate.id} className={styles.funnelWrapper}>
                <Funnel width="100%" color={colors[index % colors.length]} />
                <Text className={styles.funnelText}>{rate.text}</Text>

                {rate.percentage && (
                  <Box className={styles.funnelChip}>
                    <Icon
                      icon="icon-flechaabajo"
                      className={styles.funnelChipIcon}
                    />
                    <Text className={styles.funnelChipText}>
                      {rate.percentage}
                    </Text>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
          <Box className={styles.totalContainer}>
            <Box className={styles.totalChip}>
              <Icon icon="icon-flechaabajo" className={styles.funnelChipIcon} />
              <Text className={styles.funnelChipText}>
                {funnel.fallen_percentage}
              </Text>
            </Box>
            <Text className={styles.totalLost}>
              {Trans(
                translations,
                'CountTotalLost',
                String(funnel.fallen_count)
              )}
            </Text>
          </Box>
        </Box>
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
